/**
 * Info Message Module
 */

class InfoMessage {
  #element;
  #closeButton;

  /**
   * @constructor
   * @param {HTMLElement} element element to bind to
   */
  constructor(element) {
    this.#element = element;
    this.#closeButton = this.#element.querySelector('.info-message__close');

    if (this.#closeButton) {
      this.#bindEvents();
    }
  }

  /**
   * Binds the necessary event listeners
   */
  #bindEvents() {
    this.#closeButton.addEventListener('click', this.#handleCloseClick.bind(this));
  }

  /**
   * Handles the click event on the close button
   * @param {Event} event - The click event
   */
  #handleCloseClick(event) {
    event.preventDefault();
    this.#element.remove();
  }

  static init() {
    const infoMessages = document.querySelectorAll('.js-info-message');

    infoMessages.forEach(el => {
      new InfoMessage(el);
    });
  }
}

export default InfoMessage;
